var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.8333 6.16666H3.52499L7.59166 2.1C7.91666 1.775 7.91666 1.24166 7.59166 0.916663C7.26666 0.591663 6.74166 0.591663 6.41666 0.916663L0.924994 6.40833C0.599994 6.73333 0.599994 7.25833 0.924994 7.58333L6.41666 13.075C6.74166 13.4 7.26666 13.4 7.59166 13.075C7.91666 12.75 7.91666 12.225 7.59166 11.9L3.52499 7.83333H12.8333C13.2917 7.83333 13.6667 7.45833 13.6667 7C13.6667 6.54166 13.2917 6.16666 12.8333 6.16666Z","fill":"#424D57"}));
}

ArrowLeftInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
